var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4129",
    transform: "translate(-207,-1485)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    "data-name": "Rectangle 8818",
    width: 12,
    height: 12,
    rx: 100,
    fill: "#ff6e6e",
    opacity: 0.24,
    transform: "translate(235,1513) translate(-6,-6)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 1501,
    "data-name": "Rectangle 8817",
    width: 24,
    height: 24,
    rx: 12,
    fill: "#ff6e6e",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229,
    y: 1507,
    "data-name": "Rectangle 8818",
    width: 12,
    height: 12,
    rx: 6,
    fill: "#ff6e6e",
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cl-dummy-circle",
    x: 229,
    y: 1507,
    "data-name": "Rectangle 8818",
    width: 12,
    height: 12,
    rx: 100,
    fill: "#ff6e6e",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 1510,
    "data-name": "Rectangle 8934",
    width: 6,
    height: 6,
    rx: 3,
    fill: "#ff6e6e",
    opacity: 0.72
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCircle);
export default __webpack_public_path__ + "static/media/red-circle.2ca13a6b.svg";
export { ForwardRef as ReactComponent };